/* tslint:disable */
require('./FieldAttachmentsRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_32f6f713',
  relative: 'relative_32f6f713',
  container: 'container_32f6f713',
  fabricIcon: 'fabricIcon_32f6f713',
};

export default styles;
/* tslint:enable */